import { isSSR } from "../ssr";
interface PageVariables {
  language: string;
  pageCategory1: string;
  pageCategory2: string;
  pageType: string;
}

interface GeolocationVariables {
  countryCode?: string;
  market?: string;
}

const getAAMarket = (
  market: string | undefined,
  countryCode: string | undefined
): string | undefined => {
  if (countryCode === "US" || countryCode === "CA") return "US";
  if (market === "FT") return "LAM";
  if (market === "AS") return "AP";
  if (market === "EU") return "EMEA";
  return market;
};

export const setAdobeAnalyticsPageVariables = ({
  language,
  pageCategory1,
  pageCategory2,
  pageType
}: PageVariables): void => {
  if (isSSR()) return;
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    track_current_page: window.location.href.split("?")[0],
    page_cat1: pageCategory1,
    page_cat2: pageCategory2,
    track_page_type: pageType,
    user_language: language
  });
};

export const setAdobeAnalyticsGeolocationVariables = ({
  countryCode,
  market
}: GeolocationVariables): void => {
  if (isSSR()) return;
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    user_country: countryCode,
    user_geo_adwords: getAAMarket(market, countryCode)
  });
};
